import { createStore, applyMiddleware } from "redux";
import thunk from "redux-thunk";
import { composeWithDevTools } from 'redux-devtools-extension';
import RootReducer from '../reducers/rootReducer.js';
import { save, load } from "redux-localstorage-simple";

const middlewares = [thunk];
if (process.env.NODE_ENV !== "production") {
  const { logger } = require("redux-logger");
  middlewares.push(logger);
}

let store;

const configureStore = (preloadedState = {}) => {
  store = process.env.NODE_ENV !== "production"
    ? createStore(
        RootReducer,
        //load({ preloadedState }),
        preloadedState,
        composeWithDevTools(applyMiddleware(...middlewares))
      )
    : createStore(
        RootReducer,
        //load({ preloadedState }),
      preloadedState,
        applyMiddleware(...middlewares)
      );
      return store;
}
  

export const getStore = () => store;

export default configureStore;